import { createReducer } from "../../../utils/create-reducer";
import { USERS_LIST_V2 } from "../../../utils/action-names.json";

const usersList = createReducer(USERS_LIST_V2);

export default usersList;
